import React from "react";
import { motion } from "framer-motion";
import { Target, Timer, Trophy } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import SectionLabel from "./SectionLabel";

const ICONS = [Target, Timer, Trophy];

export default function HowItWorks() {
  const { t } = useI18n();

  return (
    <section id="how" data-testid="how-section" className="relative py-20 md:py-32 border-t border-line">
      <div className="container-px mx-auto max-w-7xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <SectionLabel>{t.how.label}</SectionLabel>
            <h2 className="mt-6 font-display font-bold text-ink text-balance leading-[1.05]
                           text-3xl sm:text-5xl lg:text-6xl max-w-2xl">
              {t.how.title}
            </h2>
          </div>
        </div>

        <div className="mt-14 relative">
          {/* connector line on desktop */}
          <div className="hidden md:block absolute top-12 left-0 right-0 h-px bg-line" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
            {t.how.steps.map((step, i) => {
              const Icon = ICONS[i] || Target;
              return (
                <motion.div
                  key={step.k}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.55, delay: i * 0.12 }}
                  className="relative"
                  data-testid={`how-step-${i}`}
                >
                  <div className="relative grid h-24 w-24 place-items-center rounded-2xl hairline mb-6"
                       style={{ background: "rgba(0,255,136,0.04)" }}>
                    <span className="absolute -top-2 -right-2 mono-num text-[10px] text-bg bg-primary px-2 py-0.5 rounded-md">
                      {step.k}
                    </span>
                    <Icon size={32} color="#00FF88" strokeWidth={1.6} />
                  </div>
                  <h3 className="font-display text-ink text-2xl font-semibold">{step.t}</h3>
                  <p className="text-ink/60 mt-3 leading-relaxed text-[15px] max-w-sm">{step.d}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
